import { render, staticRenderFns } from "./DashboardSysadmin.vue?vue&type=template&id=a65683a2&"
import script from "./DashboardSysadmin.vue?vue&type=script&lang=js&"
export * from "./DashboardSysadmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSysadmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports